import { Suspense, lazy, type ReactNode } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { SkeletonCards, ToastProvider } from '@serota/ui-web';
import { Login } from './auth/Login';
import { RequireAuth } from './components/Guard';
import { translateLegacyPath } from './lib/legacy-paths';
import { queryClient } from './lib/query';
import { SessionProvider } from './lib/session';
import { adminRoutes } from './routes';

const AdminLayout = lazy(() => import('./components/AdminLayout').then((m) => ({ default: m.AdminLayout })));

function Fallback() {
  return (
    <div className="sr-page">
      <SkeletonCards count={6} height={112} />
    </div>
  );
}

/** Eski İngilizce adres (yer imi, paylaşılmış bağlantı) → Türkçe karşılığı; arama ve # korunur. Bilinmeyen adres → ana sayfa. */
function LegacyRedirect() {
  const loc = useLocation();
  const to = translateLegacyPath(loc.pathname);
  return <Navigate to={to ? { pathname: to, search: loc.search, hash: loc.hash } : '/'} replace />;
}

function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<Fallback />}>{children}</Suspense>;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <BrowserRouter>
          <ToastProvider>
            <Routes>
              <Route path="/giris" element={<Login />} />
              <Route
                path="/"
                element={
                  <RequireAuth>
                    <Lazy>
                      <AdminLayout />
                    </Lazy>
                  </RequireAuth>
                }
              >
                {adminRoutes}
              </Route>
              <Route path="*" element={<LegacyRedirect />} />
            </Routes>
          </ToastProvider>
        </BrowserRouter>
      </SessionProvider>
    </QueryClientProvider>
  );
}
